import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OutputFieldComponent } from './output-field/output-field.component';
import { OutputPageHeaderComponent } from './output-page-header/output-page-header.component'; 
import { RouterModule } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { OutputEmptyStateComponent } from './output-empty-state/output-empty-state.component'; 
import { FdsButtonLoadingComponent } from './rds-button-loading/rds-button-loading.component';
import { LoadingTableComponent } from './loading-table/loading-table.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { LoadingChartComponent } from './loading-chart/loading-chart.component';
import { LoadingComponent } from './loading/loading.component';



@NgModule({
  declarations: [
    OutputFieldComponent, 
    OutputPageHeaderComponent, 
    OutputEmptyStateComponent, 
    FdsButtonLoadingComponent, LoadingTableComponent, LoadingChartComponent, LoadingComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    MatFormFieldModule,
    NgxSkeletonLoaderModule,
    MatCardModule
  ],
  exports: [
    OutputFieldComponent, 
    OutputPageHeaderComponent, 
    OutputEmptyStateComponent, 
    FdsButtonLoadingComponent, LoadingTableComponent, LoadingChartComponent, LoadingComponent
  ]
})
export class FinexFormModule { }
